module.exports = __webpack_public_path__ + "37d97ed26a5af913435405b4f85f3ed3.pdf";